import { Box, Toolbar, Typography,Modal ,Card, TextField, Button, Divider ,Checkbox,Paper, Grid2, Link} from '@mui/material'
import { Container } from '@mui/system'
import React, { Component } from 'react'
import { useNavigate,useLocation, useParams } from 'react-router-dom';
import BannerSlider from './BannerSlider';
import MobileBannerSlider from './MobileBannerSlider';
import bg2 from './bachround_img/bg.jpg'
import bg from './bachround_img/bg2.jpg'
import bg3 from './bachround_img/bg3.jpg'
import bg4 from './bachround_img/bg4.jpg'
import bg5 from './bachround_img/bg5.png'

import product1 from './product_img/product1.png'
import base_url from './base_url'





export class Pageone extends Component {
constructor(props) {
  super(props)
  
  this.state = {
    city:"",
    data:[],


    form_open : false,
    name  :"",
    email_id  : "",
    phone_no  : "",

/////////////////////////////////////////////////////
 bannerList: [],
 categoryList :[],
 productList : [],




  }
  this.handleChange = this.handleChange.bind(this)
}



handleChange=(e)=>{


}



  componentDidMount(){

   fetch(
         `${base_url.base}/banner/retriveAllBanerList`,
         {
           headers: {
             "content-type": "application/json",
           },
           method: "get",
         }
       )
         .then((res) => {
           return res.json();
         })
         .then((result) => {
           console.log(result)
           this.setState({
             bannerList: result.data,
           });
         });


         fetch(
               `${base_url.base}/category/retriveCategoryListForselect`,
               {
                 headers: {
                   "content-type": "application/json",
                 },
                 method: "get",
               }
             )
               .then((res) => {
                 return res.json();
               })
               .then((result) => {
                 console.log(result)
                 this.setState({
                   categoryList: result.data,

                 });
               });


                   fetch(`${base_url.base}/product/retriveSomeProductList`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
       
        this.setState({ productList: result.data })
      });

  }









///////

















renderMenu(){
    return(
      <Box sx={{ height:100,backgroundColor:'blue'}}>
    
      </Box>
     )
  }
















  render() {
     let desktopBanner =  this.state.bannerList.filter(item => item.banner_type == "Desktop Banner");
     let mobileBanner = this.state.bannerList.filter(item => item.banner_type == "Mobile Banner");
    return (
      <div>
{
  /// #00cfe8
  /// rgba(32, 35, 72,0.88)
  //
}
      <Box>




<Box sx={{mt:6,display:{xs:'none',sm:'none',md:'block'}}}>
  <BannerSlider bannerList={desktopBanner}/>
</Box>


<Box sx={{mt:6,display:{xs:'block',sm:'block',md:'none'}}}>
  <MobileBannerSlider bannerList={mobileBanner}/>
</Box>






<Box sx={{backgroundImage: `url(${bg2})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    minHeight: 1000, // Mandatory for visibility if content is empty
    width: '100%'}}>


     <Container maxWidth='xl' >
       <Box sx={{minHeight:500}}>
           
           <br/>
 
 
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            overflowX: "scroll",
                            overflowY: "hidden",
                            mb: 1,
                            whiteSpace: "nowrap",
                            scrollbarWidth: "none",
                          }}
                        >
             <Box sx={{m:3,width:'100%'}}>
              <Grid2 container spacing={{xs:3,sm:2}}>

                    {this.state.categoryList.map((e)=>(

                    <Grid2 size={{xs:12,sm:6,md:3}}>
                       <Box sx={{height:300,width:'100%',border:2,borderColor:'#997320',borderRadius:3}}>
                             
                             <Box sx={{height:36,width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                              <Typography textAlign='center' sx={{fontSize:17,fontWeight:'700',color:'#997320'}}>{e.category_name}</Typography>
                              </Box> 
                       
                          <Box sx={{backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    minHeight:260, // Mandatory for visibility if content is empty
    borderBottomRightRadius:5,
    borderBottomLeftRadius:5,
    width: '100%'}}>

              <Box sx={{height:250,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <img src={base_url.base+'/'+e.category_img} style={{height:200,width:'100%',objectFit:'cover'}}/>
  
                  <Button
                  onClick={()=>this.props.navigate('/itemList',{ state: { category: e.category_name } })}
  variant="contained"
  sx={{
    mt:9,
    backgroundImage:  `url(${bg3})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '30px', // Optional: set dimensions
    width: '150px',
    color: 'white',  // Ensure text remains readable
    fontWeight:'bold',

  }}
>
  Shop Now
                  </Button>
              </Box>



                          </Box>

                       </Box>
                    </Grid2>

                    ))

                      
                    }
                  

                  

              </Grid2>
            </Box>
</Box>

       
    <Box sx={{height:10,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',mt:6,mb:3}}>
       <Typography textAlign='center' sx={{fontSize:17,fontWeight:'bold',fontFamily:'sans-serif'}}>Product List</Typography>
      <img src={bg5} style={{height:20,width:'80%',objectFit:'cover'}}/>
    </Box>
             
           

             <Box sx={{m:3}}>
              <Grid2 container spacing={{xs:3,sm:2}}>

                {this.state.productList.map((e)=>(
                  <Grid2 size={{xs:6,sm:4,md:2}}>
                       <Paper   sx={{height:220,width:'100%',borderRadius:3}}>
           
            
                  <Box  sx={{backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderTopRightRadius:2,
     borderTopLeftRadius:2,
    backgroundPosition: 'center',
    minHeight:150, // Mandatory for visibility if content is empty
    width: '100%'}}>

                  <Box sx={{height:150,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <img src={base_url.base+'/'+e.thumb_nail_img} style={{height:150,width:'100%',objectFit:'contain'}}/>
  
                          </Box>
                  </Box>



                          <Box sx={{height:70,width:'100%',backgroundColor:'green',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',

                               borderBottomRightRadius:2,
     borderBottomLeftRadius:2,
                          }}>
                  
                    <Typography textAlign='center' sx={{fontSize:15,fontWeight:'700',color:'#e49f0c',mb:0.6}}>{e.product_name}</Typography>
                            
                  <Button
                  onClick={()=>this.props.navigate(`/itemDescription/:${e.product_id}`)}
  variant="contained"
  sx={{
    backgroundImage:  `url(${bg3})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '30px', // Optional: set dimensions
    width: {xs:'120px',sm:'150px'},
    color: 'white',  // Ensure text remains readable
    fontWeight:'bold',

  }}
>
  Shop Now
                  </Button>


                          </Box>







                       </Paper>
                    </Grid2>
                ))
                    

                }

              </Grid2>
            </Box>




<br/>
<br/>
           







        </Box>
     </Container>
</Box>













<Divider/>
 </Box>
      </div>
    )
  }
}



export function Pageonec(props){
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams()
  return (<Pageone navigate={navigate} location={location} params={params}></Pageone>)
}





export default Pageone



















